import { ReactNode, useRef } from 'react';
import { HomepageContext } from './HomepageContext';

// Until I can figure it out, we need this because the dashboard keeps re-mounting, but we only want to view the dialog ONCE per login/user switch,
// instead of showing the dialog every time it re-mounts.
export default function HomepageProvider({ children }: { children: ReactNode }) {
  const hasViewedNoDefaultBankAccountDialog = useRef(false);

  return (
    <HomepageContext.Provider
      value={{
        hasViewedNoDefaultBankAccountDialog,
      }}
    >
      {children}
    </HomepageContext.Provider>
  );
}
